export const NoBreakSpace = '\u00a0';
export const SpacedLongDash = '\u00a0\u2014\u00a0';
export const NewLine = '\u000A';